module.exports = __webpack_public_path__ + "img/img_cx1.99f36749.jpg";